import React, { FC } from 'react';
import clsx from 'classnames';
import LogoImg from 'assets/logo.png';
import { HeaderActions } from 'common/layout/header-actions/header-actions';
import { HeaderDrawerProvider } from 'common/layout/mobile-drawer/header-drawer.context';
import MobileDrawer from 'common/layout/mobile-drawer/mobile-drawer';
import { HeaderProps } from './header.types';

import styles from './header.module.scss';

export const Header: FC<HeaderProps> = props => (
  <HeaderDrawerProvider>
    <header className={clsx(styles.header)}>
      <nav className={clsx(styles.navBar, styles.bgHeader)}>
        <div className={styles.logoContainer}>
          <img alt="logo" className={styles.headerLogo} src={LogoImg} />
          <MobileDrawer isBackBehaviorEnable={props?.isBackBehaviorEnable} />
        </div>

        <h3 className="text-primary uppercase flex-1 text-center">{props.title}</h3>

        {props.children}
        <HeaderActions {...props} className={styles.options} />
      </nav>
    </header>
  </HeaderDrawerProvider>
);

Header.defaultProps = {
  isAuthenticated: false,
  onSignOut: () => {},
  title: 'CONTROL VEHICULAR',
} as any;

export default React.memo(Header);
